module.exports = __webpack_public_path__ + "img/statistic.0b9a92fc.svg";